// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 *
 * These names can be found by running `reactOverridableEnableDevMode()`
 * in the console on the upload form.
 */

import React from "react";
import { FieldLabel, RichInputField, TextField } from "react-invenio-forms";
import { AdditionalDescriptionsField } from "@js/invenio_rdm_records/src/deposit/fields/DescriptionsField/components";
import { AdditionalTitlesField } from "@js/invenio_rdm_records/src/deposit/fields/TitlesField/AdditionalTitlesField";

const DESCRIPTION_HELP =
  "A summary describing the purpose, nature, and scope of the dataset.";

const DescriptionWithHelp = ({
  fieldPath,
  editorConfig,
  htmlFor,
  icon,
  label,
  recordUI,
  options,
  disabled,
  required,
  optimized,
}) => (
  <>
    <RichInputField
      className="description-field rel-mb-1 rel-mt-2"
      fieldPath={fieldPath}
      editorConfig={editorConfig}
      label={<FieldLabel htmlFor={htmlFor} icon={icon} label={label} />}
      optimized={optimized}
      disabled={disabled}
      required={required}
      helpText={DESCRIPTION_HELP}
    />
    <AdditionalDescriptionsField
      recordUI={recordUI}
      options={options}
      editorConfig={editorConfig}
      optimized={optimized}
      fieldPath="metadata.additional_descriptions"
    />
  </>
);

const TITLE_HELP =
  "A name to aid in identifying the dataset";

const TitleWithHelp = ({ options, recordUI, placeholder, optimized }) => (
  <>
    <TextField
      fieldPath="metadata.title"
      helpText={TITLE_HELP}
      placeholder={placeholder}
      label={<FieldLabel htmlFor="metadata.title" icon="book" label="Title" />}
      required
      className="title-field"
      optimized={optimized}
    />
    <AdditionalTitlesField
      options={options}
      recordUI={recordUI}
      fieldPath="metadata.additional_titles"
      optimized={optimized}
    />
  </>
);

export const overriddenComponents = {
  "InvenioRdmRecords.DepositForm.DescriptionsField.Container": DescriptionWithHelp,
  "InvenioRdmRecords.DepositForm.TitlesField.Container": TitleWithHelp,
  "InvenioAppRdm.Deposit.AccordionFieldReferences.container": () => null,
  "InvenioAppRdm.Deposit.CopyrightsField.container": () => null,
}
